import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ui-kit-icon --icon" }
const _hoisted_2 = { class: "ui-kit-icon__wrapper" }
const _hoisted_3 = { class: "ui-kit-icon__error footnote color-error" }
const _hoisted_4 = { class: "ui-kit-icon__selections" }
const _hoisted_5 = { class: "ui-kit-icon__selections-field --size" }
const _hoisted_6 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "caption-navbar" }
const _hoisted_9 = { class: "ui-kit-icon__selections-field__customer" }
const _hoisted_10 = { class: "ui-kit-icon__selections-field --color" }
const _hoisted_11 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "caption-navbar" }
const _hoisted_14 = { class: "ui-kit-icon__selections-field --position" }
const _hoisted_15 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "caption-navbar" }
const _hoisted_18 = { class: "icons-folder-item__name caption-normal" }
const _hoisted_19 = { class: "icons-folder-item__descr" }
const _hoisted_20 = {
  key: 0,
  class: "footnote"
}
const _hoisted_21 = {
  key: 1,
  class: "footnote"
}
const _hoisted_22 = {
  key: 2,
  class: "footnote"
}
const _hoisted_23 = { class: "ui-kit-icon__row --line --wrap" }
const _hoisted_24 = { class: "icon-block__name" }
const _hoisted_25 = { class: "ui-kit-icon__container ui-kit-icon__row --wrap" }
const _hoisted_26 = { class: "ui-kit-icon__selections" }
const _hoisted_27 = { class: "ui-kit-icon__selections-field --size" }
const _hoisted_28 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "caption-navbar" }
const _hoisted_31 = { class: "ui-kit-icon__selections-field --color" }
const _hoisted_32 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "caption-navbar" }
const _hoisted_35 = { class: "ui-kit-icon__selections-field --radius" }
const _hoisted_36 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "caption-navbar" }
const _hoisted_39 = { class: "ui-kit-icon__selections-field__customer" }
const _hoisted_40 = { class: "ui-kit-icon__selections-field --position" }
const _hoisted_41 = { class: "ui-kit-icon__selections-field__tabs" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "caption-navbar" }
const _hoisted_44 = { class: "ui-kit-icon__selections-field --isButton" }
const _hoisted_45 = { class: "ui-kit-icon__selections-field__switch" }
const _hoisted_46 = { class: "ui-kit-icon__selections-field --disabled" }
const _hoisted_47 = { class: "ui-kit-icon__selections-field__switch" }
const _hoisted_48 = { class: "icon-block__name" }
const _hoisted_49 = { class: "icon-block__component" }

import BaseIcon from "@/components/base/BaseIcon.vue";
import { computed, ref, watch } from "vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseSwitcher from "@/components/base/BaseSwitcher.vue";

type sizeFigureStruct = "small" | "medium" | "large" | "extra-large";
type colorFigureStruct =
  | "customer"
  | "white"
  | "white-opacity-15"
  | "white-opacity-40"
  | "purple"
  | "grey-full"
  | "grey-secondary"
  | "primary"
  | "secondary";
type positionFigureStruct = "left" | "right" | "bottom" | "top";


export default /*@__PURE__*/_defineComponent({
  __name: 'UiKitIcon',
  setup(__props) {

_useCssVars(_ctx => ({
  "219621cf": (isGradient.value ? "var(--color-white)": computedColor.value),
  "a1cec078": (isGradient.value ? computedColor.value: "var(--color-grey-blue)"),
  "441816ca": (computedColor.value),
  "2a813991": (selectSizeIcon.value)
}))

const tabsSizeIcon = ref(["16px", "20px", "24px", "32px", "38px"]);
const tabsRadiusFigure = ref(["1px", "16px", "50%"]);
const tabsSizeFigure = ref<sizeFigureStruct[]>([
  "small",
  "medium",
  "large",
  "extra-large",
]);
const tabsColorFigure = ref<colorFigureStruct[]>([
  "customer",
  "white",
  "white-opacity-15",
  "white-opacity-40",
  "purple",
  "grey-full",
  "grey-secondary",
  "primary",
  "secondary",
]);
const tabsColor = ref([
  "--color-primary",
  "--color-secondary",
  "--color-tertiary",
  "--color-text-primary",
  "--color-text-secondary",
  "--color-text-tertiary",
  "--color-text-addons",
  "--color-text-input",
  "--color-white",
  "--color-grey-light",
  "--color-grey-blue",
  "--color-bg-primary",
  " --color-bg-secondary",
  "--color-bg-tertiary",
  "--color-bg-input",
  "--color-danger-primary",
  "--color-danger-secondary",
  "--color-success",
  "--color-count",
  "--gradient-main",
]);
const tabsPosition = ref<positionFigureStruct[]>([
  "left",
  "right",
  "bottom",
  "top",
]);

const selectSizeIcon = ref("24px");
const selectRadiusFigure = ref("50%");
const selectSizeFigure = ref<sizeFigureStruct>("medium");
const selectColorFigure = ref<colorFigureStruct>("white");
const selectPosition = ref<positionFigureStruct>("right");
const selectColor = ref("--color-secondary");
const inputSize = ref("");
const inputRadiusFigure = ref("");
const textError = ref("");
const switchDisabled = ref(false);
const switchIsButton = ref(false);

const isGradient = computed(() =>
  ["--gradient-main"].includes(selectColor.value)
);

const iconsData = ref({
  folders: [
    {
      name: "ui",
      list: [
        "account",
        "arrow",
        "bell",
        "book",
        "card-pay",
        "check-checkbox",
        "check-sharp",
        "check-success",
        "close",
        "convert",
        "copy",
        "details",
        "dots",
        "download",
        "earth",
        "edit",
        "folder",
        "info",
        "list-search",
        "mail",
        "more",
        "notification",
        "phone",
        "phoneretro",
        "plus",
        "promo",
        "question",
        "rate",
        "ruble",
        "search",
        "service-arrow",
        "services",
        "settings",
        "sim",
        "star",
        "transactions",
        "travel",
      ],
    },
    {
      name: "display",
      list: ["check-success"],
    },
    {
      name: "service",
      list: [
        "ok",
        "rutube",
        "tg",
        "viber",
        "vk",
        "whatsapp",
        "max",
        "yandex-maps",
        "yandex-music",
      ],
    },
    {
      name: "payments",
      list: ["sber-pay"],
    },
  ],
});

const computedColor = computed(() => `var(${selectColor.value})`);

const toggleTabsSizeIcon = (item: string) => {
  selectSizeIcon.value = item;
  inputSize.value = "";
};
const toggleTabsSizeFigure = (item: sizeFigureStruct) => {
  selectSizeFigure.value = item;
};
const toggleTabsColorFigure = (item: colorFigureStruct) => {
  selectColorFigure.value = item;
};
const toggleTabsColor = (item: string) => {
  selectColor.value = item;
};
const toggleTabsPosition = (item: positionFigureStruct) => {
  selectPosition.value = item;
};
const toggleTabsRadiusFigure = (item: string) => {
  selectRadiusFigure.value = item;
  inputRadiusFigure.value = "";
};

watch(
  () => inputSize.value,
  (inputValue) => {
    if (!inputValue) {
      textError.value = "";
      selectSizeIcon.value = "24px";
    } else if (+inputValue <= 3 || +inputValue >= 151)
      return (textError.value =
        "Установлено количественное ограничение на ввод чисел 3<i<151");
    else {
      selectSizeIcon.value = inputValue + "px";
      textError.value = "";
    }
  }
);
watch(
  () => inputRadiusFigure.value,
  (inputValue) => {
    if (!inputValue) {
      selectRadiusFigure.value = "50%";
    } else {
      selectRadiusFigure.value = inputValue;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "ui-kit-icon__head" }, [
        _createElementVNode("span", null, "Icons and Colors ")
      ], -1)),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "ui-kit-icon__text" }, [
        _createElementVNode("span", null, "BaseIcon")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(textError.value), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " --icon-size (scss, default: 24px): ", -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsSizeIcon.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectSizeIcon.value == item }]),
                onClick: ($event: any) => (toggleTabsSizeIcon(item))
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(item), 1)
              ], 10, _hoisted_7))
            }), 128)),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "caption-navbar",
                oninput: "this.value = this.value.replace(/[^0-9]/g, '')",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSize).value = $event)),
                type: "number"
              }, null, 512), [
                [_vModelText, inputSize.value]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "px", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, "color (scss):", -1)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsColor.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectColor.value == item }]),
                onClick: ($event: any) => (toggleTabsColor(item))
              }, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(item), 1)
              ], 10, _hoisted_12))
            }), 128))
          ]),
          _cache[7] || (_cache[7] = _createTextVNode(" если вдруг придётся применить к базовой иконке градиент, то передать пропсом в baseIcon isGradient и в стилях задать variables --icon-gradient-background "))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " position (props) (актуально для стрелок, default: \"right\"): ", -1)),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsPosition.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectPosition.value == item }]),
                onClick: ($event: any) => (toggleTabsPosition(item))
              }, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(item), 1)
              ], 10, _hoisted_16))
            }), 128))
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconsData.value.folders, (folder, indexFolder) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "icons-folder-item",
          key: indexFolder
        }, [
          _createElementVNode("p", _hoisted_18, " folder: " + _toDisplayString(folder.name), 1),
          _createElementVNode("div", _hoisted_19, [
            (folder.name === 'ui')
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Папка \"ui\" - по умолчанию: квадратные иконки "))
              : _createCommentVNode("", true),
            (folder.name === 'display')
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "В папке \"display\": неквадратные иконки, окно просмотра ровно по svg. Размеры меняются переопределением width/height через класс в месте вызова компонента. "))
              : _createCommentVNode("", true),
            (folder.name === 'service')
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, " При сохранении оригинальных цветов, передавать props is-original-color "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folder.list, (icon, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "icon-block --folder"
              }, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(icon), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-block__component", [{ '--gradient': isGradient.value }, `--folder-${folder.name}`]])
                }, [
                  _createVNode(BaseIcon, {
                    name: icon as string,
                    folder: folder.name,
                    "is-original-color": 
                  ['service', 'payments'].includes(folder.name)
                ,
                    position: selectPosition.value,
                    isGradient: isGradient.value,
                    class: "icon"
                  }, null, 8, ["name", "folder", "is-original-color", "position", "isGradient"])
                ], 2)
              ]))
            }), 128))
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_25, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "ui-kit-icon__text" }, [
          _createElementVNode("span", null, "BaseFigureForIcon ")
        ], -1)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " size (props, default: medium): ", -1)),
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsSizeFigure.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectSizeFigure.value == item }]),
                  onClick: ($event: any) => (toggleTabsSizeFigure(item))
                }, [
                  _createElementVNode("p", _hoisted_30, _toDisplayString(item), 1)
                ], 10, _hoisted_29))
              }), 128))
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, " ( 24*24 - small, 36*36 - medium, 48*48 - large, 64*64 - extra-large ) ", -1)),
          _createElementVNode("div", _hoisted_31, [
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " color (props, default: \"white\"): ", -1)),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsColorFigure.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectColorFigure.value == item }]),
                  onClick: ($event: any) => (toggleTabsColorFigure(item))
                }, [
                  _createElementVNode("p", _hoisted_34, _toDisplayString(item), 1)
                ], 10, _hoisted_33))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " radius (props, default: \"50%\"): ", -1)),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsRadiusFigure.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectRadiusFigure.value == item }]),
                  onClick: ($event: any) => (toggleTabsRadiusFigure(item))
                }, [
                  _createElementVNode("p", _hoisted_38, _toDisplayString(item), 1)
                ], 10, _hoisted_37))
              }), 128)),
              _createElementVNode("div", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  class: "caption-navbar",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputRadiusFigure).value = $event))
                }, null, 512), [
                  [_vModelText, inputRadiusFigure.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " position (props) (актуально для стрелок, default: \"right\"): ", -1)),
            _createElementVNode("div", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsPosition.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["ui-kit-icon__selections-field__tabs-item", { '--active': selectPosition.value == item }]),
                  onClick: ($event: any) => (toggleTabsPosition(item))
                }, [
                  _createElementVNode("p", _hoisted_43, _toDisplayString(item), 1)
                ], 10, _hoisted_42))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " is-button (props, default: false): ", -1)),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(BaseSwitcher, {
                modelValue: switchIsButton.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((switchIsButton).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "ui-kit-icon__selections-field__name" }, " disabled (props, default: false): ", -1)),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(BaseSwitcher, {
                modelValue: switchDisabled.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((switchDisabled).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["ui-kit-icon__row --line --wrap", {
            '--grey-bg ': [
              'white',
              'customer',
              'white-opacity-15',
              'white-opacity-40',
              'purple',
            ].includes(selectColorFigure.value),
          }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconsData.value.folders[0].list, (icon, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "icon-block"
            }, [
              _createElementVNode("p", _hoisted_48, _toDisplayString(icon), 1),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(BaseFigureForIcon, {
                  icon: icon,
                  color: selectColorFigure.value,
                  size: selectSizeFigure.value,
                  position: selectPosition.value,
                  radius: selectRadiusFigure.value,
                  disabled: switchDisabled.value,
                  "is-button": switchIsButton.value
                }, null, 8, ["icon", "color", "size", "position", "radius", "disabled", "is-button"])
              ])
            ]))
          }), 128))
        ], 2)
      ])
    ])
  ]))
}
}

})